import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICruiseData } from '../../../../../interfaces/src/lib/interfaces/index';
import { loadFromSessionStorage } from '../../genericUtils/genericUtils';
import { mscGet } from '../../utilFuncs/mscStorageClient';
// Initial state for the cruise data
const initialState: ICruiseData = {
  cruiseID: null,
  departureDate: null,
  arrivalDate: null,
  name: null,
  brand: null,
  title: null,
  duration: null,
  departurePort: null,
  arrivalPort: null,
  isInstantConfirmation: null,
  areInfantsAllowed: true,
  ageRestriction: {
    appliesToLeadPassenger: false,
    minimumAge: 18,
  },
  ribbon: loadFromSessionStorage(
    'cruise_promo_badge',
    mscGet<string>('session', 'cruise_promo_badge') || ''
  ),
};

// Create the slice
const cruiseDataSlice = createSlice({
  name: 'cruiseData',
  initialState: loadFromSessionStorage('cruiseData', initialState),
  reducers: {
    setCruiseData: (state: ICruiseData, action: PayloadAction<ICruiseData>) => {
      state.cruiseID = action.payload.cruiseID;
      state.departureDate = action.payload.departureDate;
      state.arrivalDate = action.payload.arrivalDate;
      state.name = action.payload.name;
      state.brand = action.payload.brand;
      state.title = action.payload.title;
      state.duration = action.payload.duration;
      state.departurePort = action.payload.departurePort;
      state.arrivalPort = action.payload.arrivalPort;
      state.isInstantConfirmation = action.payload.isInstantConfirmation;
      state.ageRestriction = action.payload.ageRestriction;
      state.areInfantsAllowed = action.payload.areInfantsAllowed;
      state.season = action.payload.season;
    },
  },
});

// Export the actions
export const { setCruiseData } = cruiseDataSlice.actions;

// Export the reducer
export default cruiseDataSlice.reducer;
